<p-dialog *ngIf="message && display" header="{{message.title}}" [showHeader]="true" [(visible)]="display" [modal]="true" [responsive]="true"
    [ngClass]="dialogColorStyle" (visibleChange)="onClose()">
    <div class="ui-dialog-body" style="text-align: left !important;">
        <div [innerHTML]="processMessage(message.text)"></div>
    </div>
    <p-footer>
        <button type="button" pButton pRipple icon="pi pi-check" (click)="onClose()" label="{{l('Ok')}}" [ngClass]="buttonColorStyle"></button>
    </p-footer>
</p-dialog>

<p-dialog *ngIf="message && displayConfirmation" header="{{message.header || l('Confirmation')}}" [showHeader]="true" [(visible)]="displayConfirmation" [modal]="true"
    [ngClass]="!hasCustomConfirmStyle() ? dialogColorStyle : ''" [styleClass]="message.styleClass || ''" [responsive]="true" [style]="getConfirmDialogStyle()" [minY]="70" [baseZIndex]="10000">
    <div class="ui-dialog-body" [ngClass]="{'app-alert-confirm-body': hasCustomConfirmStyle()}">
        <ng-container *ngIf="hasCustomConfirmStyle(); else defaultConfirmBody">
            <div class="app-alert-confirm-message">
                <span class="app-alert-confirm-icon pi pi-exclamation-triangle"></span>
                <div class="app-alert-confirm-text" [innerHTML]="processMessage(message.message)"></div>
            </div>
            <div *ngIf="isAcceptDisabled()" class="app-alert-countdown">
                <span class="pi pi-clock"></span>
                <div>
                    Podrá confirmar en {{acceptDisabledRemaining}} segundo(s).
                </div>
            </div>
        </ng-container>
        <ng-template #defaultConfirmBody>
            <div [innerHTML]="processMessage(message.message)"></div>
            <div *ngIf="isAcceptDisabled()" class="p-message p-message-info" style="margin-top: 1rem;">
                <div class="p-message-wrapper">
                    <span class="p-message-icon pi pi-info-circle"></span>
                    <div class="p-message-text">
                        Podrá confirmar en {{acceptDisabledRemaining}} segundo(s).
                    </div>
                </div>
            </div>
        </ng-template>
    </div>
    <p-footer>
        <button type="button" pButton pRipple (click)="onConfirmReject()" label="{{message.cancelTitle}}" class="p-button-outlined" [ngClass]="buttonColorStyle"></button>
        <button type="button" pButton pRipple (click)="onConfirmAccept()" [label]="getAcceptButtonLabel()" [disabled]="isAcceptDisabled()" [ngClass]="buttonColorStyle"></button>
    </p-footer>
</p-dialog>
